import { FormControlLabel, formGroupClasses, Radio, RadioGroup, Stack, Typography } from "@mui/material";
import React from "react";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { CircuitCreateStepperData } from "./circuitCreateStepper";

interface CircuitCreateStepperPackageStockByRoomProps {
    data: CircuitCreateStepperData;
    setData: React.Dispatch<React.SetStateAction<CircuitCreateStepperData>>;
    stepIndex: number;
}

// use_stock ? => stock sur le package
// use_product_stock => stock des produits

export const CircuitCreateStepperPackageStockByRoom: FC<CircuitCreateStepperPackageStockByRoomProps> = ({ data, setData, stepIndex }) => {
    const { t } = useTranslation();
    const onChange = (event: { target: { name: any; value: any; }; }) => {
        setData((state) => ({ ...state, [event.target.name]: event.target.value === 'true' }));
    };
    return (
        <Stack direction={'column'} justifyContent={'center'} sx={{ maxWidth: 'md', width: '100%', gap: 7 }}>
            <Stack direction={'column'} spacing={1}>
                <Typography variant="h3" sx={{ color: '#486284', fontWeight: 700 }}>{t('shared.step-number', { count: stepIndex + 1 })} : {t('shared.stock-by-room-type')}</Typography>
                <Typography variant="subtitle1" sx={{ color: '#8CA2C0', fontWeight: 400 }}>{t('shared.package-stock-by-room-helper')}</Typography>
            </Stack>
            <Stack direction={'row'} alignItems={'center'} sx={{ width: '100%' }} spacing={2}>
                <RadioGroup
                    value={data.stock_by_rooms ? 'true' : 'false'}
                    name="stock_by_rooms"
                    onChange={onChange}
                    sx={{
                        [`&.${formGroupClasses.root}`]: {
                            gap: 2
                        }
                    }}
                >
                    <FormControlLabel
                        value={'true'}
                        control={<Radio sx={{ '& .MuiSvgIcon-root': { fontSize: '1.7rem' } }} />}
                        label={t("shared.stock-by-rooms")}
                        componentsProps={{ typography: { sx: { fontSize: '1.5rem' }, variant: 'body1' } }}
                    />
                    <FormControlLabel
                        value={'false'}
                        control={<Radio sx={{ '& .MuiSvgIcon-root': { fontSize: '1.7rem' } }} />}
                        label={t("shared.stock-by-pax")}
                        componentsProps={{ typography: { sx: { fontSize: '1.5rem' }, variant: 'body1' } }}
                    />
                </RadioGroup>

            </Stack>
        </Stack>
    );
};